import { gql } from 'graphql-request';
import type { Fields } from '@/pages/Home';
import { contentfulQuery } from '@/utilities/contentful';

export type TermsAndConditionsFields = Pick<
  Fields,
  'id' | 'title' | 'subtitle' | 'longContentOne'
>;
interface QueryResponse {
  swsAboutPageSectionsCollection: {
    items: TermsAndConditionsFields[];
  };
}

type FieldNames = 'terms-and-conditions';

export const queryKey = ['TERMS_AND_CONDITION_CONTENT'];

export async function getTermsAndConditions() {
  const query = gql`
    query getTermsAndConditions {
      swsAboutPageSectionsCollection(
        where: { id_in: ["terms-and-conditions"] }
      ) {
        items {
          id
          title
          subtitle
          longContentOne
        }
      }
    }
  `;

  const contentfulData = await contentfulQuery<QueryResponse>(query);

  const data = contentfulData?.swsAboutPageSectionsCollection.items.reduce(
    (obj, item) => {
      return {
        ...obj,
        [item.id]: item,
      };
    },
    {}
  ) as Record<FieldNames, TermsAndConditionsFields>;

  return data;
}
